import React, { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { fetchImportEventList } from 'gqlQueries/promoRecommendation';

const errorMessage: string = 'Something went wrong!';

function useFetchEventDataList(slice = 0) {
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<any | null>([]);

    //To fetch dim
    const [fetchEventDataList, { data: eventData, loading: eventLoading, error: eventtError }] = useLazyQuery(
        fetchImportEventList,
        {
            onCompleted: onFetchComplete,
            onError: onFetchError,
        },
    );

    useEffect(() => {
        setLoading(eventLoading);
    }, [eventLoading]);

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            let list = payload.getEventsList.map((data: any) => {
                return {
                    ...data,
                };
            });
            setData(() => list);
        } catch (error) {
            console.error(errorMessage, error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        //sending empty data to error to avoid null data being sent
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        setData,
        fetchEventDataList: (variables: any) => {
            fetchEventDataList(variables);
        },
    };
}

export default useFetchEventDataList;
